//@ts-nocheck
import React, { useState } from "react";
import styles from "./EditContinuationActions.module.scss";
import useCustomForm from "hooks/useCustomForm";
import { TextFieldWrapper, Button } from "@factorearth/component-library";

function EditContinuationActions(props) {
	const { actions, color, handleSubmitActions } = props;

	const [currentActions, setCurrentActions] = useState(actions || []);
	const [toggleNewAction, setToggleNewAction] = useState(false);

	const { values, handleChange, handleSubmit, errors } = useCustomForm({ newAction: "" }, null);

	function renderActions() {
		const list = currentActions.map((action) => {
			return <div>{action}</div>;
		});
		return (
			<div>
				{list}
				<Button colorPalette={color} onClick={handleNewClick} data-test="new-continuation-action-btn">
					New Continuation Action
				</Button>
			</div>
		);
	}

	function handleNewClick() {
		setToggleNewAction(true);
	}

	function submitNewAction(e) {
		const newActionValue = values.newAction;

		const existing = [...currentActions];
		existing.push(newActionValue);
		setCurrentActions(existing);
		handleChange({ target: { name: "newAction", value: "" } });
		setToggleNewAction(false);
	}

	function handleSubmitNewActions() {
		handleSubmitActions(currentActions);
	}

	function cancelNewAction() {
		setToggleNewAction(false);
	}

	return (
		<div>
			<div>
				CONTINUATION ACTIONS!
				{toggleNewAction ? (
					<div>
						<label style={{ color: color.text.secondary }} className={styles.header} htmlFor="edit_newAction">
							New Action:
						</label>
						<TextFieldWrapper
							onChange={handleChange}
							value={values.newAction}
							name="newAction"
							id="edit_newAction"
							type="text"
							placeholder="new action"
							colorPalette={color}
						/>
						<Button colorPalette={color} onClick={submitNewAction}>
							Submit New Action
						</Button>
						<Button colorPalette={color} onClick={cancelNewAction}>
							Cancel new action
						</Button>
					</div>
				) : null}
				<div>
					{renderActions()}
					<button onClick={handleNewClick}>New Continuation Action</button>
					<button onClick={handleSubmitNewActions}>Submit Actions</button>
				</div>
			</div>
		</div>
	);
}

export default EditContinuationActions;
